import http from './http-services';
import config from '../config/headers';
import tokenGenerator from '../utils/tokenGenerator';
import { getAPIURL } from '../utils/envGetter';

const apiUrl = getAPIURL();

export async function getAttachments(id) {
  config.headers = { 'Content-Type': 'application/json', Authorization: tokenGenerator() };
  const { data } = await http.get(`${apiUrl}/attachment/${id}`, config);
  return data;
}

export async function addAttachment(formData) {
  config.headers = { 'Content-Type': 'multipart/form-data', Authorization: tokenGenerator() };
  config.timeout = 600000;
  const { data } = await http.post(`${apiUrl}/attachment`, formData, config);
  return data;
}

export async function deleteAttachment(id) {
  config.headers = { 'Content-Type': 'application/json', Authorization: tokenGenerator() };
  config.timeout = 600000;
  const { data } = await http.delete(`${apiUrl}/attachment/${id}`, config);
  return data;
}
